'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import AppLogo from '@/components/ui/AppLogo';
import { Bell, LogIn, Menu, X, Search, User,  } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const navLinks = [
  { label: 'BL Tracking', href: '/', icon: Search },
  { label: 'My Alerts', href: '/my-alerts', icon: Bell },
];

export default function Topbar() {
  const pathname = usePathname();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-card border-b border-border shadow-card">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 h-16 flex items-center justify-between gap-4">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2 shrink-0">
          <AppLogo size={36} />
          <span className="font-bold text-xl text-primary tracking-tight hidden sm:block">
            EzyTrack
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks?.map((link) => {
            const Icon = link?.icon;
            const active = pathname === link?.href;
            return (
              <Link
                key={`nav-${link?.href}`}
                href={link?.href}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-150 ${
                  active
                    ? 'bg-secondary text-primary' :'text-muted-foreground hover:bg-muted hover:text-foreground'
                }`}
              >
                <Icon size={16} />
                {link?.label}
              </Link>
            );
          })}
        </nav>

        {/* Right actions */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            href="/sign-up-login-screen"
            className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold text-primary border border-primary hover:bg-secondary transition-all duration-150"
          >
            <LogIn size={15} />
            Sign In
          </Link>
          <Link
            href="/sign-up-login-screen"
            className="btn-primary flex items-center gap-2 px-4 py-2 text-sm"
          >
            <User size={15} />
            Register
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden p-2 rounded-lg text-muted-foreground hover:bg-muted transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle navigation"
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden bg-card border-t border-border fade-in">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks?.map((link) => {
              const Icon = link?.icon;
              const active = pathname === link?.href;
              return (
                <Link
                  key={`mobile-nav-${link?.href}`}
                  href={link?.href}
                  onClick={() => setMobileOpen(false)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-semibold transition-all duration-150 ${
                    active
                      ? 'bg-secondary text-primary' :'text-muted-foreground hover:bg-muted'
                  }`}
                >
                  <Icon size={16} />
                  {link?.label}
                </Link>
              );
            })}
            <div className="border-t border-border mt-2 pt-2 flex flex-col gap-2">
              <Link
                href="/sign-up-login-screen"
                onClick={() => setMobileOpen(false)}
                className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-sm font-semibold text-primary border border-primary hover:bg-secondary"
              >
                <LogIn size={15} />
                Sign In
              </Link>
              <Link
                href="/sign-up-login-screen"
                onClick={() => setMobileOpen(false)}
                className="btn-primary flex items-center justify-center gap-2 px-4 py-3 text-sm"
              >
                <User size={15} />
                Register Free
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}